/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type Device, DeviceSchema } from './device'

/* TypeScript */
export type CTALink = {
  link: ContentLink
  label: string
  hiddenDevices?: Device[]
}

/* Schemas */
export const CTALinkSchema = z.object({
  link: ContentLinkSchema,
  label: z.string(),
  hiddenDevices: z.array(DeviceSchema).optional(),
})

/* Schemas validation */
type TestCTALink = ExpectTrue<Equal<CTALink, z.infer<typeof CTALinkSchema>>>
